document.querySelectorAll('.kpr-brand-proof').forEach((root) => {
  const tabs = Array.from(root.querySelectorAll('[data-kpr-decision-tab]'));
  const panels = Array.from(root.querySelectorAll('[data-kpr-decision-panel]'));

  if (!tabs.length || !panels.length) return;

  const activate = (name, moveFocus = false) => {
    tabs.forEach((tab) => {
      const active = tab.dataset.kprDecisionTab === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      if (active && moveFocus) tab.focus();
    });

    panels.forEach((panel) => {
      const active = panel.dataset.kprDecisionPanel === name;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab.dataset.kprDecisionTab));
    tab.addEventListener('keydown', (event) => {
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      activate(tabs[next].dataset.kprDecisionTab, true);
    });
  });
});
